import type { ChatMessage } from "../hooks/chat-message";
import { ChatInput } from "./chat-input";
import { MessageList } from "./message-list";

interface ChatPanelProps {
  messages: ChatMessage[];
  activeMsgId: string | null;
  isPending: boolean;
  onSend: (question: string) => void;
  onCitePillClick: (citationNumber: number) => void;
  onActivateMessage: (msgId: string) => void;
}

export const ChatPanel: React.FC<ChatPanelProps> = ({
  messages,
  activeMsgId,
  isPending,
  onSend,
  onCitePillClick,
  onActivateMessage,
}) => (
  <div className="flex flex-col min-w-0 h-full">
    <MessageList
      messages={messages}
      activeMsgId={activeMsgId}
      onCitePillClick={onCitePillClick}
      onActivateMessage={onActivateMessage}
    />
    <ChatInput onSend={onSend} disabled={isPending} />
  </div>
);
